import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import BihamtaTable from "../../Components/BihamtaTable";
import { getCreditorDebtorList } from "../store/api/DocumentsAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBalanceScale } from "@fortawesome/free-solid-svg-icons";
import ModalSelectCostCenter from "../Components/ModalSelectCostCenter";
import { exportToExcel, keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import { BookmarkFill, CaretLeft, CloudArrowDown, EyeFill, EyeSlashFill, FileEarmarkExcelFill, JournalText, List, PrinterFill, Search, Slash, SlashLg } from "react-bootstrap-icons";
import ModalAccountCheck from "../Components/ModalAccountCheck";
import BihamtaMultiSelect from "../Components/BihamtaMultiSelect";

const CreditorDebtorList = () => {
    const total = useRef({});
    const history = useHistory();
    const dispatch = useDispatch();
    const attachmentTypes = useRef([]);
    const { handleSubmit } = useForm();
 
    const [pending, setPending] = useState(false);
    const [showFilter, setShowFilter] = useState(true);
    const [selectedCostCenter, selectCostCenter] = useState(null);
    const [popAccCheck, setPopAccCheck] = useState({ show: false });
    const [popCostCenter, setPopCostCenter] = useState({ show: false });
    const { list, stateFilters } = useSelector(state => { return { list: state.DocumentReducer.creditorDebtorList, stateFilters: state.DocumentReducer.creditorDebtorFilters } });
    const filterData = useRef({ PDateFrom: "", PDateTo: "", DateFrom: null, DateTo: null, Debtor: true, ManualDocs: false });
   const initDebt = stateFilters ? stateFilters.Debtor :true;
    const [debtors, setDebtors] = useState(initDebt);

    if (list?.Data && Array.isArray(list.Data)) {
        total.current.Debit = list.Data.map(l => l.Debit).reduce((a, b) => a + b, 0);
        total.current.Credit = list.Data.map(l => l.Credit).reduce((a, b) => a + b, 0);
        total.current.RemainedDebit = list.Data.map(l => l.RemainedDebit).reduce((a, b) => a + b, 0);
        total.current.RemainedCredit = list.Data.map(l => l.RemainedCredit).reduce((a, b) => a + b, 0);
    }
    else {
        total.current.Debit = total.current.Credit = total.current.RemainedCredit = total.current.RemainedDebit = 0;
    }
    const selectOptions = [
        { Value: "ManualDocs", Text: "سندهای دستی" },
        { Value: "Sale", Text: "فروش و انبار" },
        { Value: "Install", Text: "نصب" },
        { Value: "Repair", Text: "تعمیر" }
    ]
    function onAttachmentTypesChanged(item) {
        filterData.current[item.value] = item.checked;
    }
    function search() {
        if (filterData.current.Install) {
            if (!attachmentTypes.current.some(a => a === "install"))
                attachmentTypes.current.push("install");
        }
        else {
            attachmentTypes.current.remove("install");
        }
        if (filterData.current.Repair) {
            if (!attachmentTypes.current.some(a => a === "repair"))
                attachmentTypes.current.push("repair");
        }
        else {
            attachmentTypes.current.remove("repair");
        }
        if (filterData.current.Sale) {
            attachmentTypes.current.push("Sale", "FormalSale", "Purchase", "FormalPurchase", "ReturnFromSale", "FormalReturnFromSale", "FormalReturnFromPurchase",
                "ReturnFromPurchase", "Borrow", "ReturnFromBorrow");
        }
        filterData.current.AttachmentTypes = attachmentTypes.current;
        const pDateFrom = document.getElementsByName("DateFrom")[0].value;
        filterData.current.PDateFrom = pDateFrom;
        if (pDateFrom === "") {
            filterData.current.DateFrom = null;
        }
        const pDateTo = document.getElementsByName("DateTo")[0].value;
        filterData.current.PDateTo = pDateTo;
        filterData.current.CostCenterName = selectedCostCenter?.CenterName ?? "";
        if (pDateTo === "") {
            filterData.current.DateTo = null;
        }
        dispatch(getCreditorDebtorList(filterData.current));

    }
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "کد حساب تفصیلی", colName: "AccountCodeLThree", showInMobile: true },
        { colTitle: "نام حساب تفصیلی", colName: "AccountNameLThree", showInMobile: true },
        { colTitle: "بدهکار", colName: "Debit", showInMobile: false, colType: "currency" },
        { colTitle: "بستانکار", colName: "Credit", showInMobile: false, colType: "currency" },
        { colTitle: "مانده بدهکار", colName: "RemainedDebit", showInMobile: false, colType: "currency", showCondition: () => debtors },
        { colTitle: "مانده بستانکار", colName: "RemainedCredit", showInMobile: false, colType: "currency", showCondition: () => !debtors },
        {colTitle:"شماره تماس", colName:"CustomerMobile+CustomerPhone", colType:"string"},
        { colTitle: "رنگ گروه", colName: "AccCheckColor", colType: "color", showInMobile: false },
        { colTitle: "شرح بررسی", colName: "AccCheckDescription", colType: "color", showInMobile: false, showCondition: () => 0 === 1 }
    ];
    const tableRowButtons = [
        {
            title: "توضیحات", tooltip: "توضیحات ردیف", type: "common", className: "group-Btn-smalll btn-primary", onclick: showModalAccountCheck, icon: <BookmarkFill color="#811849" size={18} className="rowBtn" />
        },
        {
            title: "نمایش حساب", tooltip: "نمایش حساب", type: "common", className: "group-Btn-smalll btn-info", onclick: showAccountingReport, icon: <JournalText color="#0f5489" size={18} className="rowBtn" />
        }
    ]
    function showModalAccountCheck(row) {
        setPopAccCheck({ show: true, checkType: "CreditorDebtorList", relationID: row.AccountID, accountCat: row.AccountCat, onSave: () => dispatch(getCreditorDebtorList(filterData.current)) });
    }
    function rowClick(row) {
        history.push(`/Accounting/ViewAccountsReport/Customers/${row.AccountCat}/${row.AccountID}`);
    }
    function toExcel() {
        const url = "api/DocumentsAPI/CreditorDebtorList";
        const searchArgs = { ...filterData.current };
        setPending(true);
        exportToExcel("CreditorDebtorList", searchArgs, url, "post", tableColes, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData.current };
        history.push({
            pathname: `/PrintViewer/CreditorDebtorList/${e.ctrlKey}`,
            state: {
                dataUrl: `api/DocumentsAPI/CreditorDebtorList`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function showModalCostCenter(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
            filterData.current.CostCenterID = data?.ID;
            selectCostCenter(data);
        }
        setPopCostCenter({
            show: true,
            onSelect: onSelect
        });

    }
    function setDebtor(value) {
        filterData.current.Debtor = value;
        setDebtors(value);
    }
    function showAccountingReport(row) {
        if (row.e.ctrlKey) {
            window.open(`/Accounting/ViewAccountsReport/Customers/${row.AccountCat}/${row.AccountID}`);
        }
        else {
            history.push(`/Accounting/ViewAccountsReport/Customers/${row.AccountCat}/${row.AccountID}`);
        }
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    useEffect(() => {
        document.body.classList = "notMain";
        dispatch(getCreditorDebtorList({ Debtor: true }));
    }, []);
    return (
        <div className="container-fluid mt-2">
            <br />
            <ModalSelectCostCenter popData={popCostCenter} setPopCostCenter={setPopCostCenter} />
            <ModalAccountCheck popData={popAccCheck} setPopData={setPopAccCheck} />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faBalanceScale} size="lg" />
                    &nbsp;
                    لیست بدهکاران/بستانکاران
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <form onSubmit={handleSubmit(search)}>
                        <Row id="divFilters" className="rowBorder" >
                            <div className="rowTitle">
                                فیلترهای جستجو&nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                            </div>
                            <Col md={1} className="form-group">
                                <label>از تاریخ: </label>
                                <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DateFrom" onChange={value => filterData.current.DateFrom = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={1} className="form-group">
                                <label>تا تاریخ: </label>
                                <DatePicker className="form-control" isGregorian={false} timePicker={false} name="DateTo" onChange={value => filterData.current.DateTo = value.local("en").format("YYYY-MM-DD")} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مرکز هزینه</label>
                                <input type="text" className="form-control" onKeyDown={showModalCostCenter} readOnly value={selectedCostCenter?.CenterName ?? ""} />
                                <Button className="btn-input-tiny" style={{ top: "26.5px" }}><List size={22} onClick={showModalCostCenter} /></Button>
                            </Col>
                            <Col md={2} className="form-group" style={{ color: "#0047ff" }}>
                                <label style={{ color: "black" }}>نوع سند:</label>
                                <BihamtaMultiSelect dataSource={selectOptions} valueItem="Value" displayItem="Text" onItemCheckChanged={onAttachmentTypesChanged} />
                            </Col>
                            <Col md={2} className="form-group" style={{ maxWidth: "max-content", fontSize: "13px" }}>
                                <label>نوع گزارش:</label>
                                <div className="rowBorder mt-1" style={{ padding: "5px" }}>
                                    <label style={{ color: "#ff4000", lineHeight: 1.9 }}>
                                        <input className="form-check-input" type="radio" name="Debtor" onChange={e => setDebtor(e.target.checked)} defaultChecked={stateFilters?.Debtor ?? true} />&nbsp;بدهکاران
                                    </label>&nbsp;
                                    <label style={{ color: "#049366", lineHeight: 1.9 }}>
                                        <input className="form-check-input" type="radio" name="Debtor" onChange={e => setDebtor(!e.target.checked)} defaultChecked={!(stateFilters?.Debtor ?? true)} />&nbsp;بستانکاران
                                    </label>
                                </div>
                            </Col>
                        </Row>
                        <div className="mt-1">
                            <Button type="submit" variant="secondary" className="group-Btn-large" style={{ display: "block" }}><Search size={15} />&nbsp;نمایش  گزارش&nbsp;</Button>
                        </div>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} filterData={filterData.current} rowClick={rowClick} hasPaging={true} fixedHeight
                        searchMethod={(data) => dispatch(getCreditorDebtorList(data))} reducerName="DocumentReducer" objectName="creditorDebtorList" className="mt-0 mb-0" />
                    <table>
                        <thead>
                            <tr>
                                <th>بدهکار</th>
                                <th>بستانکار</th>
                                {debtors && <th>مانده بدهکار</th>}
                                {!debtors && <th>مانده بستانکار</th>}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <input className="tableRowInput" style={{ color: "red" }} value={total.current.Debit?.toLocaleString(navigator.languages)} readOnly />
                                </td>
                                <td>
                                    <input className="tableRowInput" style={{ color: "blue" }} value={total.current.Credit?.toLocaleString(navigator.languages)} readOnly />
                                </td>
                                {debtors && <td>
                                    <input className="tableRowInput" style={{ color: "red" }} value={total.current.RemainedDebit?.toLocaleString(navigator.languages)} readOnly />
                                </td>}
                                {!debtors && <td>
                                    <input className="tableRowInput" style={{ color: "blue" }} value={total.current.RemainedCredit?.toLocaleString(navigator.languages)} readOnly />
                                </td>}
                            </tr>
                        </tbody>
                    </table>
                </Card.Body>
            </Card>
        </div>
    )

}
export default CreditorDebtorList;